"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersTable = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const common_1 = require("../../../common");
const server_1 = require("../../../server");
const classes_1 = require("../../../server/classes");
const popup_1 = require("../../base/popup");
const ui_1 = require("../ui");
const MemberRoleFilter_1 = require("./MemberRoleFilter");
exports.MembersTable = react_1.default.memo(({ id, isPopup = false, isModify, defaultValues, handlerUpdateMemberIds, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const allChoiceMemberIds = (0, react_1.useRef)(defaultValues);
    const countRef = (0, react_1.useRef)(isPopup ? 8 : 10);
    const pageCountRef = (0, react_1.useRef)(10);
    const [filterOption, setFilterOption] = (0, react_1.useState)(['all']);
    const [searchOption, setSearchOption] = (0, react_1.useState)('');
    const [page, setPage] = (0, react_1.useState)(0);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    // 필터 전체(all)·검색어 없음 상태의 total_count(총원). 참여자 카운트 분모용 —
    // totalCount 는 검색/필터 결과 수라 분모로 쓰면 총원이 아니게 된다.
    const [initialTotalCount, setInitialTotalCount] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [choiceMemberIds, setChoiceMemberIds] = (0, react_1.useState)(defaultValues);
    const modifyKlassMemberMutation = (0, react_query_1.useMutation)(classes_1.modifyKlassMember);
    const deleteKlassMemberMutation = (0, react_query_1.useMutation)(classes_1.deleteKlassMember);
    // 해당 클래스에 해당하는 사용자 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        ...(!isPopup ? { class_id: id } : {}),
        ...(filterOption.includes('all') ? { level: ['02', '03'] } : { level: filterOption }),
        ...(searchOption ? { nickname_like: searchOption } : {}),
        offset: page * countRef.current,
        limit: countRef.current,
        orderby: ['level ASC', 'id'],
    });
    const refetchRef = (0, react_1.useRef)(refetch);
    refetchRef.current = refetch;
    // 렌더마다 throttle 인스턴스가 재생성되어 스로틀이 무효화되던 것 수정 — 단일 인스턴스 유지
    const refetchList = (0, react_1.useMemo)(() => (0, lodash_1.throttle)(() => refetchRef.current(), 1000), []);
    const { headTitleList, tableReadDataKeys } = (0, react_1.useMemo)(() => {
        const headTitleList = [
            // ...(isModify && !isPopup ? [{ title: 'delete', space: 0.5, maxWidth: 40 }] : []),
            { title: 'name', space: 2 },
            { title: 'participant', space: 1 },
            ...(isPopup ? [{ title: 'status', space: 1 }] : []),
        ];
        const tableReadDataKeys = [
            // ...(isModify && !isPopup ? [{ title: 'delete', space: 0.5, maxWidth: 40 }] : []),
            { title: 'nickname', space: 2 },
            { title: 'level_name', space: 1 },
            ...(isPopup ? [{ title: 'status', space: 1 }] : []),
        ];
        return { headTitleList, tableReadDataKeys };
    }, [isModify, isPopup]);
    (0, react_1.useEffect)(() => {
        setSearchOption('');
        setPage(0);
    }, [isModify]);
    (0, react_1.useEffect)(() => {
        setChoiceMemberIds(defaultValues);
        allChoiceMemberIds.current = defaultValues;
    }, [isPopup, defaultValues]);
    react_1.default.useEffect(() => {
        setPage(0);
    }, [filterOption, searchOption]);
    react_1.default.useEffect(() => {
        refetchList();
    }, [isPopup, isModify, filterOption, searchOption, page]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            // 필터 전체(all) + 검색어 없음일 때의 total_count 가 실제 총원 — 분모용으로 기억
            if (filterOption.includes('all') && !searchOption) {
                setInitialTotalCount(total_count);
            }
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else {
                if (items.length > 0) {
                    setTestData(items);
                    setTotalCount(total_count);
                    return;
                }
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data, page]);
    const handlerMoreData = (0, react_1.useCallback)((newPage) => {
        setPage(newPage);
    }, []);
    const handlerCheckList = (0, react_1.useCallback)((selectedMemberIds) => {
        const defaultCheckList = testData
            .filter(item => allChoiceMemberIds.current.includes(item.id))
            .map(item => item.id);
        const deselectedIds = defaultCheckList.filter(id => !selectedMemberIds.includes(id));
        allChoiceMemberIds.current = [
            ...allChoiceMemberIds.current.filter(id => !deselectedIds.includes(id)),
            ...selectedMemberIds.filter(id => !allChoiceMemberIds.current.includes(id)),
        ];
    }, [testData, isPopup, allChoiceMemberIds.current]);
    const handleSearch = (0, react_1.useCallback)((searchValue) => {
        setSearchOption(searchValue);
        setPage(0);
    }, []);
    const openDialog = (0, react_1.useCallback)(() => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: exports.MembersTable,
            componentProps: {
                id,
                isPopup: true,
                isModify,
                defaultValues: allChoiceMemberIds.current,
                handlerUpdateMemberIds: (members) => {
                    refetchList();
                    allChoiceMemberIds.current = members;
                },
            },
            title: '참여자 추가',
            width: 800,
            isFit: true,
        });
    }, [isModify, allChoiceMemberIds.current]);
    const renderParticipantCount = (0, react_1.useMemo)(() => (react_1.default.createElement("p", { className: "title" },
        "\uCC38\uC5EC\uC790",
        isPopup ? (react_1.default.createElement(react_1.default.Fragment, null,
            "(",
            allChoiceMemberIds.current.length.toString().padStart(2, '0'),
            "\uBA85/",
            (initialTotalCount || totalCount).toString().padStart(2, '0'),
            "\uBA85)")) : ('(' + allChoiceMemberIds.current.length.toString().padStart(2, '0') + '명)'))), [isPopup, totalCount, initialTotalCount, allChoiceMemberIds.current.length]);
    const renderSearchBar = (0, react_1.useMemo)(() => react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: handleSearch }), [searchOption, handleSearch]);
    const renderEmpty = (0, react_1.useMemo)(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uCC38\uAC00\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderTitle = (0, react_1.useMemo)(() => {
        if (isPopup) {
            return (react_1.default.createElement("div", { className: "table-title", style: { alignItems: 'flex-end' } },
                react_1.default.createElement("div", { className: "left-wrap" },
                    renderParticipantCount,
                    react_1.default.createElement(MemberRoleFilter_1.MemberRoleFilter, { isModify: isModify, defaultValues: filterOption, handlerUpdateState: setFilterOption })),
                react_1.default.createElement("div", { className: "right-wrap" }, renderSearchBar)));
        }
        else {
            return (react_1.default.createElement("div", { className: "table-title" },
                react_1.default.createElement("div", { className: "left-wrap" }, renderParticipantCount),
                react_1.default.createElement("div", { className: "right-wrap" },
                    react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-blue btn-xmd", text: "\uCD94\uAC00 \uBC0F \uC0AD\uC81C", onClick: openDialog }),
                    renderSearchBar)));
        }
    }, [isPopup, renderParticipantCount, filterOption, renderSearchBar, openDialog]);
    const renderItem = (0, react_1.useCallback)((item) => {
        if (!item)
            return null;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: `${headItem.title}-${idx}`, className: "table-item member-item", style: {
                flex: headItem.space,
                maxWidth: headItem.maxWidth,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, (() => {
            switch (headItem.title) {
                case 'delete':
                    return (react_1.default.createElement(common_1.Button, { className: "btn-semi-round btn-line-peach btn-xsm", text: "\uC0AD\uC81C", onClick: () => {
                            const updatedIds = choiceMemberIds.filter(id => id !== item.id);
                            handlerCheckList(updatedIds);
                            setTestData(prevData => prevData.filter(data => data.id !== item.id));
                            setChoiceMemberIds(updatedIds);
                        } }));
                case 'nickname':
                    return (react_1.default.createElement("p", { className: "overText2" },
                        item[headItem.title],
                        " (",
                        item.identifier,
                        ")"));
                case 'level_name':
                    return (react_1.default.createElement("p", { className: "overText2" }, t(`common.${item[headItem.title]}`)));
                case 'status':
                    return (react_1.default.createElement("p", { className: "overText" }, item[headItem.title] === 'inactive'
                        ? t(`status.${item[headItem.title]}`)
                        : t(`status.active`)));
                default:
                    return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
            }
        })())));
    }, [tableReadDataKeys, choiceMemberIds, setTestData, handlerCheckList]);
    const defaultCheckList = (0, react_1.useMemo)(() => {
        return testData
            .filter(item => allChoiceMemberIds.current.includes(item.id))
            .map(item => item.id);
    }, [testData, allChoiceMemberIds.current]);
    const renderTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(common_1.Table, { className: "table-admin", showCheckBox: isPopup, defaultCheckList: defaultCheckList, 
            // 팝업에서는 페이지네이션을 scroll-content 밖으로(목록 아래) 분리 — 행이
            // 페이지네이션 아래로 삐져나오던 레이아웃 오류 방지. 인라인(폼)은 기존대로 유지.
            isInnerPage: !isPopup, isInfinite: false, page: page, 
            // 페이지 수 계산(ceil(totalCount/showCount))은 실제 조회 limit 과 같아야 한다.
            // 팝업은 limit=8 인데 showCount 기본값(10)으로 계산되면 총 9~10건일 때
            // 1페이지로 오판되어 페이지네이션 바가 숨겨진다(8건만 보이고 나머지 접근 불가).
            showCount: countRef.current, pagingCount: pageCountRef.current, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData, handlerCheckList: handlerCheckList }));
    }, [
        isPopup,
        page,
        pageCountRef,
        testData,
        totalCount,
        headTitleList,
        renderTitle,
        renderItem,
        renderEmpty,
        handlerMoreData,
        handlerCheckList,
    ]);
    if (isPopup) {
        return (react_1.default.createElement("div", { className: "admin-container admin-container-popup" },
            react_1.default.createElement("div", { className: "members-popup" },
                react_1.default.createElement("div", { className: "members-table-wrap" }, renderTable),
                react_1.default.createElement("div", { className: "btn-container" },
                    react_1.default.createElement(common_1.Button, { text: "\uCDE8\uC18C", className: "btn-default-round btn-grey btn-xmd", onClick: () => APP.eventManager.publish(popup_1.TOGGLE_POPUP) }),
                    react_1.default.createElement(common_1.Button, { text: "\uD655\uC778", className: "btn-default-round btn-blue btn-xmd", onClick: async () => {
                            const enrollMember = allChoiceMemberIds.current.filter(id => !defaultValues.includes(id));
                            const leaveMember = defaultValues.filter(id => !allChoiceMemberIds.current.includes(id));
                            try {
                                // 새로운 멤버 추가 처리
                                const enrollPromises = modifyKlassMemberMutation
                                    .mutateAsync({
                                    class_id: id,
                                    props: {
                                        members: enrollMember,
                                    },
                                })
                                    .then(() => ({ status: 'fulfilled', id: enrollMember }))
                                    .catch(() => ({
                                    status: 'rejected',
                                    id: enrollMember,
                                }));
                                // 기존 멤버 삭제 처리
                                const leavePromises = leaveMember && leaveMember.length <= 0
                                    ? true
                                    : deleteKlassMemberMutation
                                        .mutateAsync({
                                        class_id: id,
                                        props: {
                                            members: leaveMember,
                                        },
                                    })
                                        .then(() => ({
                                        status: 'fulfilled',
                                        id: leaveMember,
                                    }))
                                        .catch(() => ({
                                        status: 'rejected',
                                        id: leaveMember,
                                    }));
                                // Promise.allSettled을 사용하여 모든 작업의 결과를 수집
                                const results = await Promise.allSettled([
                                    enrollPromises,
                                    leavePromises,
                                ]);
                                // 처리 결과에 따라 성공/실패 분류
                                const successIds = [];
                                const failedIds = [];
                                results.forEach((result) => {
                                    const resultValue = result.value;
                                    if (resultValue.status === 'fulfilled') {
                                        successIds.push(resultValue.id);
                                    }
                                    else {
                                        failedIds.push(resultValue.id);
                                    }
                                });
                                // 멤버 업데이트 후 팝업 닫기
                                handlerUpdateMemberIds &&
                                    handlerUpdateMemberIds(allChoiceMemberIds.current);
                                refetchList();
                                APP.eventManager.publish('UPDATE_KLASS_LIST');
                                APP.eventManager.publish(popup_1.TOGGLE_POPUP);
                            }
                            catch (error) {
                                console.error('전체 에러:', error);
                            }
                        } })))));
    }
    else {
        return renderTable;
    }
});
